import { styled } from '@a0/quantum-product';
export var ButtonsContainer = styled('div')({
    display: 'flex',
    margin: 0,
});
